import { StandardEvents } from '@shopify/events';
class ProductFacts extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, async event => {
      if (event.target?.closest('product-card')) return;
      try {
        const result = await event.promise;
        if (signal.aborted) return;
        const next = result?.detail?.html?.querySelector('custom-product-facts');
        if (next) this.innerHTML = next.innerHTML;
      } catch { /* Retain confirmed facts when selection is cancelled. */ }
    }, { signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('custom-product-facts')) customElements.define('custom-product-facts', ProductFacts);
